import { Component, EventEmitter, Input, OnInit, OnDestroy, Output } from "@angular/core";
import { AuthService } from "src/app/services/auth.service";
import Epub, { EpubCFI } from "epubjs";
import { GlobalsService } from "src/app/api/globals.service";
import { MenuController } from "@ionic/angular";
import { StorageService } from "src/app/services/storage.service";
import { environment } from "src/environments/environment";
import { AuthConstants } from "src/app/config/auth-constants";
import { ToastService } from "src/app/services/toast.service";
import { EbooksService } from "src/app/services/ebooks.service";
import { TranslationLoadedService } from "src/app/services/translation-loaded.service";

export interface CurrentLocation {
  start: {
    index: number;
    href: string;
    cfi: string;
    displayed: {
      page: number;
      total: number;
    };
    location: number;
    percentage: number;
  };
  end: {
    index: number;
    href: string;
    cfi: string;
    displayed: {
      page: number;
      total: number;
    };
    location: number;
    percentage: number;
  };
  atStart: boolean;
}

@Component({
  selector: "app-epubviewer",
  templateUrl: "./epubviewer.component.html",
  styleUrls: ["./epubviewer.component.scss"],
})
export class EpubviewerComponent implements OnInit, OnDestroy {
  @Output() isModalOpenChange = new EventEmitter<boolean>();

  ngOnDestroy() {
    // Limpiar el renderizador y el contenedor cuando el componente se destruye
    if (this.RENDITION) {
      this.RENDITION.destroy();
    }
    const container = document.getElementById('area');
    if (container) {
      container.innerHTML = '';
    }
  }
  viewMarker(arg0: any) {
    this.RENDITION.display(arg0.start.cfi);
  }
  setMenuView(action: string) {
    this.menuView = action;
  }
  @Input() file: any = {};
  id_user: number = 0;
  auth_key: string = "";
  displayUserData: any;
  ismobile: boolean;
  theme: string = "";
  private RENDITION = null;
  public temasepub: string = "";
  menuView: string = "controls";

  btnActiveTheme: string = "light";
  showMenu: boolean = false;
  userDataSubscribe: any;

  marcadores: any = [];

  saveLastPage: any = null;

  public ChapterIon: any = [];
  public indexChapter: number;
  private currentLocation: CurrentLocation;
  loadDocument: boolean = false;
  gridHeight: string = "82vh";
  marginTop: string = "86px";
  modalClass = "drawer-modal desktop"; // valor por defecto
  archived: boolean = true;
  constructor(
    private authService: AuthService,
    public globalsService: GlobalsService,
    private menuCtrl: MenuController,
    private storageService: StorageService,
    public toastService: ToastService,
    private ebooksService: EbooksService,
    private _translationLoadedService: TranslationLoadedService
  ) {
    this._translationLoadedService.startLoading();
    this._translationLoadedService.isLoading$.subscribe((isLoading) => {
      this.loadDocument = isLoading;
      if (!this.loadDocument) {
        setTimeout(() => {
          this._translationLoadedService.finishLoading();
        }, 1100);
      }
    });
  }

  ngOnInit() {
    // Asegurarse de que el contenedor esté limpio al inicio
    const container = document.getElementById('area');
    if (container) {
      container.innerHTML = `
        <div id="prev" class="arrow-pag">‹</div>
        <div id="next" class="arrow-pag">›</div>
      `;
    }

    this.authService.userData$.subscribe((res: any) => {
      if (res) {
        // Limpiar estado anterior si existe
        if (this.RENDITION) {
          this.RENDITION.destroy();
          this.RENDITION = null;
        }
        
        this.displayUserData = res;
        this.ismobile = this.globalsService.isMobile;
        this.gridHeight = this.ismobile ? "92vh" : "82vh";
        this.marginTop = this.ismobile ? "57px" : "86px";
        // this.modalClass = this.ismobile ? "drawer-modal" : "drawer-modal desktop";
        this.ebooksService
          .getEbookV2(this.file.id, this.displayUserData.token)
          .subscribe(
            async (response) => {
              const base64String: any = await this.convertBlobToBase64(
                response
              );
              this.initFunctions(base64String);
            },
            (error) => {
              this.loadDocument = true;
              if (error.status === 401) {
                this.toastService.presentToast(
                  "No tiene permiso para ver el documento"
                );
              } else if (error.status === 404) {
                this.toastService.presentToast("Documento no encontrado");
              } else {
                this.toastService.presentToast(
                  "Ocurrió un error, inténtelo más tarde"
                );
              }
            }
          );
      }
    });
  }
  async initFunctions(base64String: string) {
    // Destruir el renderizador anterior si existe
    if (this.RENDITION) {
      this.RENDITION.destroy();
      this.RENDITION = null;
    }
    
    // Limpiar el contenedor y restablecer el estado
    const container = document.getElementById('area');
    if (container) {
      container.innerHTML = '';
    }
    
    // Resetear variables de estado
    this.ChapterIon = [];
    this.marcadores = [];
    this.saveLastPage = null;
    this.currentLocation = null;

    const _this = this;
    this.id_user = this.displayUserData?.id;
    this.auth_key = this.displayUserData?.auth_key;

    const headers = {
      Bearer: `${this.displayUserData.token}`,
    };

    let nameArr = base64String.split(",");
    // Limpiar cualquier caché del navegador relacionada con el libro
    try {
      window.localStorage.removeItem('epubjs.locations.' + this.file.id);
      window.localStorage.removeItem('epubjs.cfg.' + this.file.id);
    } catch (e) {
      console.warn('Error clearing epub cache:', e);
    }

    let book: any = Epub(nameArr[1], { encoding: "base64" });
    var Chapter: any = [];
    if (!book || (book && !book.archived)) {
      this.archived = false;
      return;
    }
    this.loadDocument = true;
    var rendition = book.renderTo("area", {
      width: "100%",
      height: "100%",
      ignoreClass: "annotator-hl",
      allowScriptedContent: true,
      /* flow: "paginated",
      manager: "continuous", */
    });
    //var displayed = rendition.display();
    var displayed = rendition.display();
    rendition.on("rendered", (section) => {
      const iframe = document.querySelector("iframe");
      if (iframe) {
        const doc = iframe.contentDocument || iframe.contentWindow.document;
        doc.documentElement.style.height = "100%";
        doc.body.style.height = "100%";
        doc.body.style.margin = "0";
        doc.body.style.padding = "0";
        doc.body.style.touchAction = "pan-y";
        const body = doc.body;

        let startX: number;
        let endX: number;

        body.addEventListener("touchstart", (e) => {
          startX = e.touches[0].clientX;
        });

        body.addEventListener("touchend", (e) => {
          endX = e.changedTouches[0].clientX;
          handleSwipe();
        });

        body.addEventListener("mousedown", (e) => {
          startX = e.clientX;
        });

        body.addEventListener("mouseup", (e) => {
          endX = e.clientX;
          handleSwipe();
        });

        const handleSwipe = () => {
          const threshold = 50; // distancia mínima en px para swipe
          const diff = endX - startX;

          if (Math.abs(diff) > threshold) {
            if (diff < 0) {
              // Swipe a la izquierda → siguiente página
              rendition.next();
            } else {
              // Swipe a la derecha → página anterior
              rendition.prev();
            }
          }
        };
      }
    });
    _this.RENDITION = rendition;
    _this.storageService.get(AuthConstants.epubLocation).then((resul) => {
      let dataResult = [];
      _this.marcadores = [];
      if (resul && resul[_this.file.id]) {
        let data: any = {};
        data = resul[_this.file.id];
        _this.marcadores = data.listMarkers;
        if (data.lastCfi) rendition.display(data.lastCfi);
      }
    });

    book.ready.then(function () {
      let next = document.getElementById("next");
      next.addEventListener(
        "click",
        function (e) {
          if (_this.saveLastPage) {
            clearTimeout(_this.saveLastPage);
            _this.saveLastPage = null;
          }

          _this.saveLastPage = setTimeout(function () {
            _this.addLastPageMarker();
            _this.saveLastPage = null;
          }, 5000);
          book.package.metadata.direction === "rtl"
            ? rendition.prev()
            : rendition.next();
          e.preventDefault();
        },
        false
      );

      let prev = document.getElementById("prev");
      prev.addEventListener(
        "click",
        function (e) {
          if (_this.saveLastPage) {
            clearTimeout(_this.saveLastPage);
            _this.saveLastPage = null;
          }
          _this.saveLastPage = setTimeout(function () {
            //_this.addLastPageMarker();
            _this.saveLastPage = null;
          }, 5000);
          book.package.metadata.direction === "rtl"
            ? rendition.next()
            : rendition.prev();
          e.preventDefault();
        },
        false
      );

      let keyListener = function (e) {
        // Left Key
        if ((e.keyCode || e.which) == 37) {
          book.package.metadata.direction === "rtl"
            ? rendition.next()
            : rendition.prev();
        }
        // Right Key
        if ((e.keyCode || e.which) == 39) {
          book.package.metadata.direction === "rtl"
            ? rendition.prev()
            : rendition.next();
        }
      };

      rendition.on("keyup", keyListener);
      document.addEventListener("keyup", keyListener, false);

      rendition.themes.register("dark", "/assets/epubcss/themes.css");
      rendition.themes.register("light", "/assets/epubcss/themes.css");
      rendition.themes.register("tan", "/assets/epubcss/themes.css");
      rendition.themes.select("light");
      //********************* */
      //rendition.themes.select('tan');

      // let darkTheme = document.getElementById("dark-theme");
      // darkTheme.addEventListener(
      //   "click",
      //   function (e) {
      //     let event: any;
      //     event = e;
      //     let t = event.target.getAttribute("data-theme");
      //     _this.btnActiveTheme = t;
      //     rendition.themes.select(t);
      //     e.preventDefault();
      //   },
      //   false
      // );
      // //let selectTheme = document.getElementById("select-theme");
      // let lightTheme = document.getElementById("light-theme");
      // lightTheme.addEventListener(
      //   "click",
      //   function (e) {
      //     let event: any;
      //     event = e;
      //     let t = event.target.getAttribute("data-theme");
      //     _this.btnActiveTheme = t;
      //     rendition.themes.select(t);
      //     e.preventDefault();
      //   },
      //   false
      // );
      // let tanTheme = document.getElementById("tan-theme");
      // tanTheme.addEventListener(
      //   "click",
      //   function (e) {
      //     let event: any;
      //     event = e;
      //     let t = event.target.getAttribute("data-theme");
      //     _this.btnActiveTheme = t;
      //     rendition.themes.select(t);
      //     e.preventDefault();
      //   },
      //   false
      // );

      rendition.on("relocated", function (location) {
        var next =
          book.package.metadata.direction === "rtl"
            ? document.getElementById("prev")
            : document.getElementById("next");
        var prev =
          book.package.metadata.direction === "rtl"
            ? document.getElementById("next")
            : document.getElementById("prev");

        if (location.atEnd) {
          next.style.visibility = "hidden";
        } else {
          next.style.visibility = "visible";
        }

        if (location.atStart) {
          prev.style.visibility = "hidden";
        } else {
          prev.style.visibility = "visible";
        }
      });
      /************ */
      book.loaded.navigation.then(function (toc) {
        let select: any = document.getElementById("toc"),
          docfrag = document.createDocumentFragment();
        let index = 0;
        toc.forEach(function (chapter) {
          let option: any = document.createElement("option");
          option.textContent = chapter.label;
          option.ref = chapter.href;
          option.value = index;

          docfrag.appendChild(option);

          Chapter.push({ index: index, label: option.innerText });
          index++;
        });
        //this.ChapterIon = Chapter;
        select.appendChild(docfrag);
        /* const _this = this; */
        select.onchange = function () {
          let index = select.selectedIndex,
            url = select.options[index].ref;
        };
        select.addEventListener(
          "change",
          function (event) {
            const spine = book.spine;

            let index = select.selectedIndex,
              url = select.options[index].ref;
            this.indexChapter = index;
            rendition.display(`${url}`);
          },
          false
        );
      });

      /* setTimeout(() => {
        rendition.display('Text/titulo.xhtml');
      }, 5000); */

      /************************ */
      // book.loaded.metadata.then(function (meta) {
      //   let title: any = document.getElementById("title");
      //   let author: any = document.getElementById("author");
      //   let cover: any = document.getElementById("cover");
      //   let nav: any = document.getElementById("navigation");
      //   title.textContent = meta?.title;
      //   author.textContent = meta?.creator;
      //   if (book.archive) {
      //     book.archive.createUrl(book.cover).then(function (url) {
      //       cover.src = url;
      //     });
      //   } else {
      //     cover.src = book.cover;
      //   }

      //   if (nav.offsetHeight + 60 < window.innerHeight) {
      //     nav.classList.add("fixed");
      //   }
      // });
    });

    /************** */
    let controlsFont: any = document.getElementById("controls-font");
    let currentPercent: any = document.getElementById("current-percent-font");
    //let sliderFont: any = document.createElement("input");
    let sliderFont: any = document.getElementById("slider-controls-font");
    let currentPage: any = document.getElementById("current-percent");

    var percentF = 100;
    let slideFontFunction: any = function () {
      percentF = sliderFont.value;
      currentPercent.value = percentF;
      rendition.themes.fontSize(percentF + "%");
      //rendition.display(cfi);
    };

    /************Slide font functions */
    /* let _this = this; */

    var mouseDown = false;
    let slider: any = document.getElementById("slider-controls-percent");
    let slide: any = function () {
      slider = document.getElementById("slider-controls-percent");
      var cfi = book.locations.cfiFromPercentage(slider.value / 100);
      slider.value = slider.value;
      rendition.display(cfi);
    };
    book.ready
      .then(function () {
        book.locations.generate(book.locations.break);
        controlsFont.style.display = "block";
        sliderFont.setAttribute("type", "range");
        sliderFont.setAttribute("style", "width: 100%");
        sliderFont.setAttribute("min", 40);
        sliderFont.setAttribute("max", 200);
        sliderFont.setAttribute("step", 1);

        sliderFont.setAttribute("value", 100);
        sliderFont.addEventListener("change", slideFontFunction, false);
        //controlsFont.appendChild(sliderFont);
        sliderFont.value = percentF;
        currentPercent.addEventListener(
          "change",
          function () {
            var pp = currentPercent.value;
            sliderFont.value = pp;
            rendition.themes.fontSize(pp + "%");
          },
          false
        );

        /*************** */
        _this.ChapterIon = null;
        _this.RENDITION = null;
        _this.ChapterIon = Chapter;
        _this.RENDITION = rendition;

        /*************** */
        let slider: any = document.getElementById("slider-controls-percent");
        let slide: any = function () {
          var cfi = book.locations.cfiFromPercentage(slider.value / 100);
        };

        currentPage.addEventListener(
          "change",
          function () {
            var cfi = book.locations.cfiFromPercentage(currentPage.value / 100);
            rendition.display(cfi);
          },
          false
        );
        rendition.on("relocated", function (location) {
          var percent = book.locations.percentageFromCfi(location.start.cfi);
          var percentage = Math.floor(percent * 100);
          //var cfi = book.locations.cfiFromPercentage(slider.value / 100);
          if (!mouseDown) {
            if (percentage > 0) slider.value = percentage;
          }
          //slider.value = percentage;
          currentPage.value = percentage;
        });
      })
      .then(function (locations) {
        try {
          slider.setAttribute("type", "range");
          slider.setAttribute("style", "width: 100%");
        } catch (error) {}

        slider.setAttribute("max", 100);
        // slider.setAttribute("max", book.locations.total+1);
        slider.setAttribute("step", 1);

        slider.setAttribute("value", 0);

        slider.addEventListener("change", slide, false);
        slider.addEventListener(
          "mousedown",
          function () {
            mouseDown = true;
          },
          false
        );
        slider.addEventListener(
          "mouseup",
          function () {
            mouseDown = false;
          },
          false
        );

        // Wait for book to be rendered to get current page
        displayed.then(function () {
          // Get the current CFI
          var currentLocation = rendition.currentLocation();
          // Get the Percentage (or location) from that CFI
          var currentPagePercent = book.locations.percentageFromCfi(
            currentLocation.start.cfi
          );
          var percentage = Math.floor(currentPagePercent * 100);
          slider.value = 0;

          //currentPage.value = currentPage;

          _this.storageService.get(AuthConstants.epubLocation).then((resul) => {
            let tempResult: any = {};
            let listMarkers: any = [];
            let lastCfi: string = "";
            let percentage: number = 0;
            if (resul) {
              tempResult = resul;
              if (tempResult[_this.file.id]) {
                listMarkers = tempResult[_this.file.id].listMarkers;
                lastCfi = tempResult[_this.file.id].lastCfi;
                percentage = tempResult[_this.file.id].percentage;
              }
            }
            const _currentLocation = {
              id_book: _this.file.id,
              ..._this.RENDITION.currentLocation(),
              listMarkers: listMarkers,
              lastCfi: lastCfi,
              percentage: percentage,
            };
            let data: Object = {};
            tempResult[_this.file.id] = _currentLocation;
            _this.storageService.storage(
              AuthConstants.epubLocation,
              tempResult
            );
          });
        });
      });
    /*************Fin Slide font function */
    rendition.on("selected", function (cfiRange, contents) {
      let view: any = contents;
      let range;
      let textNode;
      let offset;
      let cfi;
      let annotation;
      let epubcfi: any = new EpubCFI();
      // standard

      console.log("textNode: ", textNode);
      console.log("cfiRange", cfiRange);
      rendition.annotations.highlight(cfiRange, {}, (e) => {
        console.log("highlight clicked", e.target);
      }); /**** */
      rendition.annotations.highlight(
        "epubcfi(/6/14[Section0001.xhtml]!/4/50,/1:538,/1:2138)"
      );
      //rendition.annotations.highlight('');
      let annotator = false;
      book.getRange(cfiRange).then(function (range) {
        if (range) {
          console.log("RANGE", range);
          textNode = range.startContainer;
          offset = range.startOffset;
          let endoffset = range.endOffset;
          let texto: string = textNode.nodeValue;
          console.log("nodeType: ", textNode.nodeType);
          console.log("Texto: ", texto);
          console.log("startOffset: ", offset);
          console.log("endoffset: ", endoffset);
          console.log(
            "Texto seleccionado: ",
            texto.substring(offset, endoffset)
          );

          let d = book.spine.get(cfiRange);
          console.log("d: ", d);
          annotator = true;
          const position = rendition.currentLocation();
          position.start.cfi;
          //rendition.annotations.highlight(position.start.cfi)

          //rendition.display('epubcfi(/6/8[xpreface_001]!/4/2/2/2/1:0)');

          //cfi = epubcfi.generateCfiFromTextNode(textNode, offset, rendition.currentChapter.cfiBase);
        }

        //rendition.annotations.highlight(range)
        if (true) {
          rendition.hooks.content.register(function (contents, view) {
            var elements = contents.document.querySelectorAll("p");
            var items = Array.prototype.slice.call(elements);

            items.forEach(function (item) {
              console.log("register-view forEach", item.tagName);
              console.log("register-view forEach view", view);
              if (item.tagName === "P") {
                /* item.classList.add("annotator-adder")
                item.style.color = 'red'; */
              }
            });
          });
        }
        rendition.hooks.content.register(function (contents, view) {
          let _view: any = view;
          console.log("register-view: ", view);
          var adder = [
            [".annotator-adder, .annotator-outer", ["position", "fixed"]],
          ];
          /* contents.forEach(element => {
              console.log("register-view forEach", view.document.body);
              if (element.tagName === 'P') {
                console.log("view.document.body", view.document.body);
                element.style.color = 'red';
              }
            }); */
          contents
            .addScript("/assets/js/jquery.min.js")
            .then(function () {
              return contents.addScript("/assets/epubjs/annotator-full.min.js");
            })
            .then(function () {
              return contents.addStylesheet(
                "/assets/epubcss/annotator.min.css"
              );
            })
            .then(function () {
              console.log("view.document.body", view);
              contents.addStylesheetRules(adder);
              contents.window.Annotator.Util.mousePosition = function (event) {
                var body = contents.document.body;
                // var offset = view.position();
                console.log("view.document.body", contents.document.body);
                return {
                  top: event.pageY,
                  left: event.pageX,
                };
              };
              var ann = new contents.window.Annotator(view.document.body);
              console.log("view.document.body", contents.document.body);
            });
        });
      }); /***** */

      contents.window.getSelection();
      //contents.window.getSelection().removeAllRanges();
    });
  }

  setChapter(evet: any) {
    console.log(
      "setChapter: -------------------------------->",
      evet.detail.value
    );
    console.log(
      "setChapter: -------------------------------->this.indexChapter",
      this.indexChapter
    );
    let select: any = document.getElementById("toc");
    select.selectedIndex = this.indexChapter;

    let index = select.selectedIndex,
      url = select.options[index].ref;
    console.log("setChapter url: ", url);
    console.log("setChapter index:----------> ", index);
    //this.rendition.display(url);

    const event = new Event("change");
    select.dispatchEvent(event);
  }
  setTema() {
    console.log("setTema: ", this.temasepub);
    if (this.temasepub == "dark") {
      document.getElementById("dark-theme").click();
    } else if (this.temasepub == "light") {
      document.getElementById("light-theme").click();
    } else if (this.temasepub == "tan") {
      document.getElementById("tan-theme").click();
    }
  }
  async markerMenu() {
    if (this.RENDITION) {
      this.addMarker();
    }
  }
  addMarker() {
    if (this.RENDITION) {
      let currentLocation = this.RENDITION.currentLocation();
      console.log(
        "epubLocationStorage--------->result currentLocation",
        currentLocation.start.location
      );
      this.storageService.get(AuthConstants.epubLocation).then((result) => {
        let listMarkers: any = [];

        let tempResult: any = result;
        if (result && result[this.file.id]) {
          console.log(
            "epubLocationStorage--------->new Marker",
            currentLocation.start.location
          );
          let dataResult = tempResult[this.file.id];
          listMarkers = dataResult.listMarkers;

          let filteredMarkers = listMarkers.filter(
            (marker) => marker.start.location == currentLocation.start.location
          );

          if (filteredMarkers.length == 0) {
            this.toastService.presentToast("Marcador agregado", 1500);
            listMarkers.push(currentLocation);
          } else {
            let filteredMarkers = listMarkers.filter(
              (marker) =>
                marker.start.location != currentLocation.start.location
            );
            listMarkers = filteredMarkers;
            this.toastService.presentToast("Marcador eliminado", 1500);
          }

          console.log("epubLocationStorage--------->result get", result);
          dataResult.listMarkers = listMarkers;
          this.marcadores = listMarkers;
          tempResult[this.file.id] = dataResult;
          console.log("epubLocationStorage--------->new", tempResult);
          this.storageService.storage(AuthConstants.epubLocation, tempResult);
        } else {
          let lastCfi: string = "";
          let percentage: number = 0;
          const _currentLocation = {
            id_book: this.file.id,
            ...currentLocation,
            listMarkers: [currentLocation],
            lastCfi: lastCfi,
            percentage,
          };
          let tempResult: any = {};
          tempResult = result;
          /* const _currentLocation = {
            id_book: _this.file.id,
            ..._this.RENDITION.currentLocation(),
            listMarkers: [],
          }; */
          /* let data:Object = {};
          data[this.file.id] = _currentLocation */
          tempResult[this.file.id] = _currentLocation;
          this.marcadores = [currentLocation];
          console.log("epubLocationStorage--------->new", tempResult);
          this.storageService.storage(AuthConstants.epubLocation, tempResult);
        }
      });
    }
  }

  removeMarker(_marker: any) {
    if (this.RENDITION) {
      this.storageService.get(AuthConstants.epubLocation).then((result) => {
        let booksMarkers: any = {};
        booksMarkers = result;
        if (result && result[this.file.id]) {
          let dataResult: any = result[this.file.id];
          let listMarkers: any = [];
          listMarkers = dataResult.listMarkers;
          let filteredMarkers = listMarkers.filter(
            (marker) => marker.start.cfi != _marker.start.cfi
          );

          dataResult.listMarkers = filteredMarkers;
          this.marcadores = filteredMarkers;
          booksMarkers[this.file.id] = dataResult;
          this.storageService.storage(AuthConstants.epubLocation, booksMarkers);
        }
      });
    }
  }
  async addLastPageMarker() {
    if (this.RENDITION) {
      let currentLocation = this.RENDITION.currentLocation();
      console.log("_this.RENDITION--------->", currentLocation);

      this.currentLocation = currentLocation;
      console.log(
        "_this.RENDITION--------->currentLocation",
        this.currentLocation.start
      );
      this.storageService.get(AuthConstants.epubLocation).then((result) => {
        let tempResult: any = {};
        if (
          result &&
          result[this.file.id] &&
          result[this.file.id].percentage <= currentLocation.start.percentage
        ) {
          tempResult = result;
          console.log("epubLocationStorage--------->result get", result);
          let listMarkers: any = [];
          let dataResult: any = result[this.file.id];
          const _currentLocation = {
            id_book: this.file.id,
            ...currentLocation,
            listMarkers: dataResult.listMarkers,
            lastCfi: currentLocation.start.cfi,
            percentage: currentLocation.start.percentage,
          };

          tempResult[this.file.id] = _currentLocation;
          this.storageService.storage(AuthConstants.epubLocation, tempResult);
        } else {
          if (result && !result[this.file.id]) {
            const _currentLocation = {
              id_book: this.file.id,
              ...currentLocation,
              listMarkers: [],
              lastCfi: currentLocation.start.cfi,
              percentage: currentLocation.start.percentage,
            };
            let tempResult: any = {};
            tempResult = result;
            tempResult[this.file.id] = _currentLocation;
            this.storageService.storage(AuthConstants.epubLocation, tempResult);
          } else {
            if (!result) {
              const _currentLocation = {
                id_book: this.file.id,
                ...currentLocation,
                listMarkers: [],
                lastCfi: currentLocation.start.cfi,
                percentage: currentLocation.start.percentage,
              };
              let tempResult: any = {};
              tempResult[this.file.id] = _currentLocation;
              this.storageService.storage(
                AuthConstants.epubLocation,
                tempResult
              );
            }
          }
        }
      });
    }
  }
  async mostrarMenu() {
    if (!this.showMenu) {
      document.getElementById("menu-controller").style.width = "90%";
      document.getElementById("menu-controller").style.maxInlineSize = "350px";
      //document.getElementById("menu-controller").style.left = "50%";
      document.getElementById("menu-controller").style.right = "0";

      document.getElementById("ion-tab-bar").style.maxInlineSize = "350px";
      document.getElementById("ion-tab-bar").style.width = "90%";
      document.getElementById("ion-tab-bar").style.right = "0";
      this.showMenu = true;
    } else {
      this.ocultarMenu();
    }
  }

  // Para ocultar el menú lateral
  async ocultarMenu() {
    document.getElementById("menu-controller").style.width = "0";
    document.getElementById("menu-controller").style.right = "0";
    document.getElementById("ion-tab-bar").style.width = "0";
    document.getElementById("ion-tab-bar").style.right = "0";

    this.showMenu = false;
  }

  changeTheme(theme: string) {
    this.btnActiveTheme = theme;

    const r = this.RENDITION;
    if (!r?.themes) return;

    r.themes.select(theme);

    // Workaround: en algunos casos forzar re-display reordena las hojas
    const loc = r.currentLocation?.();
    if (loc?.start?.cfi) r.display(loc.start.cfi);
  }

  convertBlobToBase64 = (blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });
}
